import type { AccountInfo, EndSessionRequest } from '@azure/msal-browser';

/**
 * What Sign out tells Microsoft: which account, and the hint that names it.
 *
 * ONE CLICK, NOT THREE (2 November)
 * ---------------------------------
 * A bare logoutRedirect() does not say who is leaving, so Microsoft asked the
 * person to pick their account and then confirm - three clicks to sign out.
 * With the account's login_hint claim as logout_hint, Microsoft signs that
 * account out without asking. The claim exists only once the app registration
 * issues it (Token configuration, optional claim login_hint on the ID token);
 * without it this still sends the account, and sign-out works as before.
 */
export function signOutRequest(account: AccountInfo | null): EndSessionRequest | undefined {
  if (!account) return undefined;
  const hint = account.idTokenClaims?.['login_hint'];
  return typeof hint === 'string' && hint ? { account, logoutHint: hint } : { account };
}
